import { trackEvent } from 'lib/ui-analytics';
import { TRACKING_ACTION, TRACKING_COMPARE, TRACKING_INTERACTION } from '../Constants';

export const utagCompareRemoveCruise = (cruise, route) => {
  const { masterSailing } = cruise;
  let interaction = '';

  switch (route) {
    case '/cruises':
      interaction = TRACKING_INTERACTION.COMPARE.REMOVE_CRUISE;
      break;

    case '/cruises/compare':
      interaction = TRACKING_INTERACTION.COMPARE.REMOVE_CRUISE.replace('breadcrumb: ', '');
      break;
  }

  const event = {
    eventType: TRACKING_ACTION.INTERACTION,
    interaction,
    prodSku: [masterSailing?.itinerary?.code],
    productEvent: [TRACKING_COMPARE.COMPARE_REMOVE],
  }

  trackEvent(event);
};
